module.exports = __webpack_public_path__ + "static/storeInfo-b38023a41ae89053cac847bc8e350956.png";